"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'NavBar',
  props: ['network', 'buffer'],
  data() {
    return {
      soulWallet: null,
      reputationScore: 0
    };
  },
  watch: {
    'network.nick': {
      immediate: true,
      async handler(newNick) {
        if (!newNick) return;
        try {
          let endpoint = process.env.VUE_APP_SOUL_WALLET_ENDPOINT || 'https://verify.diggitaly.cl/webhook/wallet/soul';
          let response = await fetch(endpoint, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              nickname: newNick
            })
          });
          if (response.ok) {
            let data = await response.json();
            if (data && data.soul_wallet) {
              localStorage.setItem('soul_wallet', JSON.stringify(data));
              this.soulWallet = data.soul_wallet;
              this.reputationScore = data.reputation_score !== undefined ? data.reputation_score : 0;
              if (this.$state) this.$state.$emit('wallet.updated', data);
            } else {
              localStorage.removeItem('soul_wallet');
              this.soulWallet = null;
              this.reputationScore = 0;
              if (this.$state) this.$state.$emit('wallet.updated', null);
            }
          }
        } catch (e) {
          console.error('Error fetching dynamic soul wallet', e);
        }
      }
    }
  },
  computed: {
    networkName() {
      return this.network ? this.network.name : '';
    },
    shortWallet() {
      if (!this.soulWallet) return '';
      return `${this.soulWallet.substring(0, 6)}...${this.soulWallet.substring(this.soulWallet.length - 4)}`;
    }
  },
  methods: {
    copyWallet() {
      if (this.soulWallet) {
        navigator.clipboard.writeText(this.soulWallet).catch(err => {
          console.error('Could not copy wallet', err);
        });
      }
    },
    openWallet() {
      if (this.$state) {
        this.$state.$emit('wallet.show');
      }
    }
  }
};